// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__C_oGY","header":"ClearentDisclaimer_header__1szY4","inner":"ClearentDisclaimer_inner__ki7L0"};